import { TranslateService } from '@ngx-translate/core';
import { countSelectedRows } from './data-sheet-filters.codec';

/**
 * Zeilen-Label einer Testdatenblatt-Auswahl: „3 von 8 Zeilen", bei
 * Variablen-Bedingungen mit `≤`-Praefix, ohne Filter die reine Gesamtzahl.
 *
 * <p>NEX-1052-Review (sgraetz): Vorher stand diese Rechnung samt hart
 * einkodierter deutscher Texte mehrfach im TypeScript (Drawer, Step-Tabelle) —
 * derselbe Zustand las sich je Stelle anders und blieb auf Englisch deutsch.
 *
 * <p>Gezaehlt wird ueber {@link countSelectedRows}, deckungsgleich mit Server und
 * Engine: Ueberschneidungen zaehlen einmal, Nummern jenseits des Blatts gar nicht.
 */
export function tdbRowSelectionLabel(translate: TranslateService, total: number, filter: string): string {
  const selection = filter.trim();
  if (!selection) {
    return translate.instant('tdb.status.totalRows', { total });
  }
  const { count, bounded } = countSelectedRows(total, selection);
  return bounded
    ? translate.instant('tdb.status.rowsUpTo', { count, total })
    : translate.instant('tdb.status.rowsExact', { count, total });
}
